import { Typography } from "@mui/material";
import './style.css'
import { NavLink } from "react-router-dom";
import logo1 from '../../assets/indian_gov.png'
import logo2 from '../../assets/meg_gov.png'
import logo3 from '../../assets/pied.png'
import GoogleMap from '../../components/map/GoogleMap'
import './style.css'
export default function SideNav() {

  return (
    <div style={style.container} id="side_nav-container">
      <NavLink to="/about-us" className={`${(navData) => (navData.isActive ? 'active' : '')} sideNav_items`} style={style.item} >
        About
      </NavLink>
      <NavLink to="/training" style={style.item} className={`${(navData) => (navData.isActive ? 'active' : '')} sideNav_items`}>
        Training/ Participation/ Debutation
      </NavLink>
      <NavLink to="/district" style={style.item} className={`${(navData) => (navData.isActive ? 'active' : '')} sideNav_items`}>
        District in Meghalaya
      </NavLink>
      <NavLink to="/block" style={style.item} className={`${(navData) => (navData.isActive ? 'active' : '')} sideNav_items`}>
        Blocks in Meghalaya
      </NavLink><NavLink to="/area-village" style={style.item} className={`${(navData) => (navData.isActive ? 'active' : '')} sideNav_items`}>
        Area/Village Employement Council
      </NavLink>
      {/* <NavLink to="/annual-report" style={style.item} className={`${(navData) => (navData.isActive ? 'active' : '')} sideNav_items`}>
        Annual Reports
      </NavLink> */}
      <NavLink to="/recruitments" style={style.item} className={`${(navData) => (navData.isActive ? 'active' : '')} sideNav_items`}>
        Recruitments
      </NavLink>
      <NavLink to="/tenders" style={style.item} className={`${(navData) => (navData.isActive ? 'active' : '')} sideNav_items`}>
        Tenders
      </NavLink>
      <NavLink to="/contact-details" style={style.item} className={`${(navData) => (navData.isActive ? 'active' : '')} sideNav_items`}>
        Contact Details
      </NavLink>
      <NavLink to="/social-audit" style={style.item} className={`${(navData) => (navData.isActive ? 'active' : '')} sideNav_items`}>
        Social Audit Resource Persons
      </NavLink>
      <NavLink to="/audit-report" style={style.item} className={`${(navData) => (navData.isActive ? 'active' : '')} sideNav_items`}>
        Social Audit Reports
      </NavLink>
      <NavLink to="/governing-body" style={style.item} className={`${(navData) => (navData.isActive ? 'active' : '')} sideNav_items`}>
        Governing Body Meetings
      </NavLink>
      {/* <NavLink to="/empty" style={style.item} className={`${(navData) => (navData.isActive ? 'active' : '')} sideNav_items`}>
        Related Websites
      </NavLink> */}
      <div style={{ backgroundColor: "#f5f5dc", marginTop: "5px", boxShadow: "0 0 3px 0 black", padding: "3px" }}>
        <a rel="noopener noreferrer" href="https://www.india.gov.in/" target="_blank">
          <img src={logo1} alt="indian gov website" style={{ width: "100%" }} />
        </a>
      </div>
      <div style={{ backgroundColor: "#f5f5dc", marginTop: "5px", boxShadow: "0 0 3px 0 black", padding: "3px" }}>
        <a rel="noopener noreferrer" href="https://meghalaya.gov.in/" target="_blank">
          <img src={logo2} alt="indian gov website" style={{ width: "100%" }} />
        </a>
      </div>
      <div style={{ backgroundColor: "#f5f5dc", marginTop: "5px", boxShadow: "0 0 3px 0 black", padding: "3px" }}>
        <a rel="noopener noreferrer" href="https://megpied.gov.in/" target="_blank">
          <img src={logo3} alt="indian gov website" style={{ width: "100%" }} />
        </a>
      </div>
      <div style={{ marginTop: "10px", boxShadow: "0 0 3px 0 black" }}>
        <GoogleMap />
      </div>
    </div>
  );
}

const style = {
  container: {
    // width: "100px",
    display: "flex",
    flexDirection: "column",
    // height: "300px",
    backgroundColor: "#0b4285",
    margin: "10px 0",
    padding: "10px",
  },
  item: {
    color: "white",
    cursor: "pointer",
    fontSize: "1.1rem",
    padding: "8px",
    borderBottom: "1px solid white",
    textDecoration: "none",
  },
};
